import React, { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { toEthiopian, toGregorian } from "ethiopian-date";
import { useTranslation } from "react-i18next";
import { Tooltip } from "antd";

const EditCard = ({
    changeHandler,
    fields,
    setFieldValue,
    title,
    values,
    errors,
    handleBlur,
    touched,
    showEdit,
    handleFieldBlur
}) => {
    const [editEnabled, setEditEnaled] = useState(false);
    const convertCalendar = (calendarType, date) => {
        const formattedDate = date.replace(/\//g, "-") || "";
        const [year, month, day] = formattedDate.split("-").map(Number);

        if (calendarType === "dateOfBirth" && date.length === 10) {
            const ethiopian = toEthiopian(year, month, day);
            return `${String(ethiopian[0]).padStart(2, "0")}/${String(
                ethiopian[1]
            ).padStart(2, "0")}/${String(ethiopian[2]).padStart(2, "0")}`;
        } else if (calendarType === "dobAmh" && date.length === 10) {
            const gregorian = toGregorian(year, month, day);
            return `${String(gregorian[0]).padStart(2, "0")}/${String(
                gregorian[1]
            ).padStart(2, "0")}/${String(gregorian[2]).padStart(2, "0")}`;
        }
    };
    const handleFormConstructor = (field) => {
        switch (field.type) {
            case "text":
                return (
                    <div
                        className={`w-full ${
                            field?.grid ? field.grid : "col-span-1"
                        }`}
                    >
                        <p className='text-MetallicBlue font-semibold'>
                            {field.label} {field.name === "dateOfBirth" ? "(Gregorian)" : field.name === "dobAmh" ? "(Ethiopian)" : ""}
                        </p>
                        {(field.name === "dateOfBirth" || field.name === "dobAmh") && (
                            <p className='text-MetallicBlue text-sm'>
                                yyyy/mm/dd
                            </p>
                        )}
                        <input
                            type='text'
                            name={field.name}
                            value={values[field.name] || ""}
                            className={`bg-white border border-MetallicBlue outline-MetallicBlue w-full py-1 px-5 text-MetallicBlue ${
                                !editEnabled || field?.disabled
                                    ? "opacity-75"
                                    : ""
                            }`}
                            onChange={(e) => {
                                changeHandler(e);
                                if (field.name === "dateOfBirth") {
                                    const a = convertCalendar(
                                        field.name,
                                        e.target.value
                                    );
                                    setFieldValue("dobAmh", a);
                                } else if (field.name === "dobAmh") {
                                    const b = convertCalendar(
                                        field.name,
                                        e.target.value
                                    );
                                    setFieldValue("dateOfBirth", b);
                                }
                            }}
                            disabled={!editEnabled || field?.disabled}
                            onBlur={(e) => {
                                handleBlur(field.name)(e);
                                if (handleFieldBlur) {
                                    handleFieldBlur(field.name);
                                };
                            }}
                            maxLength={
                                field.name === "dateOfBirth" ||
                                field.name === "dobAmh"
                                    ? 10
                                    : undefined
                            }
                        />
                        {touched[field.name] && errors[field.name] ? (
                            <p className='text-red-500'>{errors[field.name]}</p>
                        ) : null}
                    </div>
                );
            case "name":
                return (
                    <div
                        className={`w-full flex flex-col gap-2 ${
                            field?.grid ? field.grid : "col-span-1"
                        }`}
                    >
                        <p className='text-MetallicBlue font-semibold w-full'>
                            {t("name")}
                        </p>
                        <input
                            type='text'
                            label='fullnameEng'
                            name='fullnameEng'
                            onChange={(e) => changeHandler(e)}
                            value={values["fullnameEng"]}
                            className={`bg-white border border-MetallicBlue outline-MetallicBlue w-full py-1 px-5 text-MetallicBlue ${
                                !editEnabled || field?.disabled
                                    ? "opacity-75"
                                    : ""
                            }`}
                            placeholder='Full Name Goes Here'
                            disabled={!editEnabled || field?.disabled}
                            onBlur={(e) => {
                                handleBlur(field.name)(e);
                                if (handleFieldBlur) {
                                    handleFieldBlur(field.name);
                                };
                            }}
                        />
                        {touched["fullnameEng"] || errors["fullnameEng"] ? (
                            <p className='text-red-500'>
                                {errors["fullnameEng"]}
                            </p>
                        ) : null}

                        <input
                            type='text'
                            label='fullnameAmh'
                            name='fullnameAmh'
                            onChange={(e) => changeHandler(e)}
                            className={`bg-white border border-MetallicBlue outline-MetallicBlue w-full py-1 px-5 text-MetallicBlue ${
                                !editEnabled || field?.disabled
                                    ? "opacity-75"
                                    : ""
                            }`}
                            value={values["fullnameAmh"]}
                            placeholder='Full Name Goes Here in Amharic'
                            disabled={!editEnabled || field?.disabled}
                            onBlur={(e) => {
                                handleBlur(field.name)(e);
                                if (handleFieldBlur) {
                                    handleFieldBlur(field.name);
                                };
                            }}
                        />
                        {touched["fullnameAmh"] || errors["fullnameAmh"] ? (
                            <p className='text-red-500'>
                                {errors["fullnameAmh"]}
                            </p>
                        ) : null}
                    </div>
                );
            case "number":
                return (
                    <div
                        className={`w-full ${
                            field?.grid ? field.grid : "col-span-1"
                        }`}
                    >
                        <p className='text-MetallicBlue font-semibold'>
                            {field.label}
                        </p>

                        <input
                            type='text'
                            name={field.name}
                            className={`bg-white border border-MetallicBlue outline-MetallicBlue w-full py-1 px-5 text-MetallicBlue ${
                                !editEnabled || field?.disabled
                                    ? "opacity-75"
                                    : ""
                            }`}
                            value={values[field.name]}
                            disabled={!editEnabled || field?.disabled}
                            onChange={(e) => changeHandler(e)}
                            onBlur={handleBlur(field.name)}
                        />
                        {touched[field.name] && errors[field.name] ? (
                            <p className='text-red-500'>{errors[field.name]}</p>
                        ) : null}
                    </div>
                );
            case "checkbox":
                return (
                    <div
                        className={`w-full ${
                            field?.grid ? field.grid : "col-span-1"
                        }`}
                    >
                        <p className='text-MetallicBlue font-semibold'>
                            {field.label}
                        </p>

                        <input
                            type='checkbox'
                            className=''
                            checked={field}
                            disabled={!editEnabled || field?.disabled}
                            onChange={(e) => changeHandler(e)}
                            onBlur={handleBlur(field.name)}
                        />
                        {touched[field.name] && errors[field.name] ? (
                            <p className='text-red-500'>{errors[field.name]}</p>
                        ) : null}
                    </div>
                );
            case "radio":
                return (
                    <div>
                        <p className='text-MetallicBlue font-semibold'>
                            {field.label}
                        </p>

                        {field.options.map((option) => (
                            <label key={option.value}>
                                <input
                                    disabled={!editEnabled || field?.disabled}
                                    className=' border border-MetallicBlue outline-MetallicBlue'
                                    type='radio'
                                    checked={field === option.value}
                                    value={option.value}
                                    onChange={(e) => changeHandler(e)}
                                    onBlur={handleBlur(field.name)}
                                />
                                {option.label}
                            </label>
                        ))}
                        {touched[field.name] && errors[field.name] ? (
                            <p className='text-red-500'>{errors[field.name]}</p>
                        ) : null}
                    </div>
                );
            case "select":
                const permanentlyDisabledFields = ['region', 'zone', 'woreda'];
                const isPermanentlyDisabled = permanentlyDisabledFields.includes(field.name);
                const tooltipTitle = "Not possible to update address at this time.";
                return (
                    <div
                        className={`w-full ${
                            field?.grid ? field.grid : "col-span-1"
                        }`}
                    >
                        <p className='text-MetallicBlue font-semibold'>
                            {field.label}
                        </p>
                        <Tooltip
                            title={isPermanentlyDisabled ? tooltipTitle : null}
                            open={isPermanentlyDisabled ? undefined : false} 
                        >
                        <select
                            disabled={!editEnabled || field?.disabled || isPermanentlyDisabled}
                            name={field.name}
                            value={values[field.name]}
                            className={`${isPermanentlyDisabled ? "disabled:bg-gray-100 disabled:opacity-75 disabled:cursor-not-allowed" : ""} border border-MetallicBlue outline-MetallicBlue py-1.5 w-full`}
                            onChange={(e) => changeHandler(e)}
                            onBlur={(e) => {
                                handleBlur(field.name)(e);
                                if (handleFieldBlur) {
                                    handleFieldBlur(field.name);
                                };
                            }}
                        >
                            <option value={0} key={0 + field.name}>
                                Select {field.name}
                            </option>
                            {field?.options?.map((option) => (
                                <option value={option.value} key={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                        </Tooltip>
                        {touched[field.name] && errors[field.name] ? (
                            <p className='text-red-500'>{errors[field.name]}</p>
                        ) : null}
                    </div>
                );
            default:
                return <p>Unsupported field type</p>;
        }
    };
    const { t } = useTranslation();
    return (
        <div className='rounded-md overflow-clip w-full shadow-lg h-full min-h-[200px]  bg-white'>
            <div className='grid grid-cols-2 place-items-center bg-MetallicBlue px-5 md:px-10 py-3 text-white'>
                <div className='w-full'>
                    <p className=''>{t(title)}</p>
                </div>
                {showEdit !== false && (
                    <button
                        type='button'
                        onClick={() => setEditEnaled(!editEnabled)}
                        className='flex items-center justify-center gap-1 bg-[#ffb400] text-MetallicBlue rounded-full w-full py-1.5'
                    >
                        {t("edit")}
                        {editEnabled ? <FaCheckCircle /> : null}
                    </button>
                )}
            </div>
            <div className='min-h-[200px] h-fit px-7 py-5 grid grid-cols-2 gap-3'>
                {fields?.map((field) => handleFormConstructor(field))}
            </div>
        </div>
    );
};

export default EditCard;
